// Radio > Radio
import React, { InputHTMLAttributes } from 'react'
import styles from './Radio.module.css'
import { RadioInputProps } from './IRadio'

export default class Radio extends React.PureComponent<
	Partial<RadioInputProps> & Partial<InputHTMLAttributes<HTMLInputElement>>
> {
	_handleRootClick = () => {
		const { value, handleRootClick } = this.props

		handleRootClick && handleRootClick(value)
	}

	/**
	 * stops the root parent div from firing it's onClick
	 */
	_handleInputClick = (event: React.MouseEvent<HTMLElement>) => {
		event.stopPropagation()
	}

	render() {
		const { name, onClick, onChange, value, handleRootClick, ...rest } = this.props

		return (
			<div onClick={this._handleRootClick} className={styles['radio-root']}>
				<input
					id={name}
					type="radio"
					name={name}
					onClick={this._handleInputClick}
					onChange={onChange}
					value={value && value.toString()}
					{...rest}
				/>
				<label htmlFor={name}>{name}</label>
			</div>
		)
	}
}
